module.exports = __webpack_public_path__ + "static/img/20161127-_MG_2634_1920x1440.36f0aa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/20161127-_MG_2634_1920x1440.jpg
// module id = nSUE
// module chunks = 1